<template>
    <HeaderMenu :style="getStyle" v-bind="$attrs"></HeaderMenu>
</template>

<script setup lang="ts">
import HeaderMenu from '@/components/menu/index.vue';
import { computed } from 'vue';
const props = defineProps({
    bgColor: {
        type: String,
        default: '#2164C9',
    },
    navTopBgColor: {
        type: String,
        default: '#2164C9',
    },
    navBottomBgColor: {
        type: String,
        default: '#2164C9',
    },
});

const getStyle = computed(() => {
    return `
        --nav-sub-bg-more-color: ${props.bgColor};
        --nav-top-bg-color: ${props.navTopBgColor};
        --nav-bottom-bg-color: ${props.navBottomBgColor};
    `;
});
</script>
